import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import store from "@src/reducers/store";
import { updateDuplicateStructureIds } from "@src/reducers/your-reducer";
import { structureHasDuplicateIds } from "./check-if-structure-has-duplicated-ids";
import { i18n } from "@src/i18n/i18n";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import * as Sentry from "@sentry/browser";

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlert =
  () => {
    const language = store.getState().yourSlice.language;
    const isAbortIfStructureHasDuplicateIds = true;
    const texts = {
      duplicateNodesError: i18n(
        "modules.checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlert.duplicateNodesError",
        language,
      ),
    };
    const duplicateIds: string[] = structureHasDuplicateIds();

    if (isAbortIfStructureHasDuplicateIds && duplicateIds.length > 0) {
      const machineStructureNodesetInstance = getMachineStructureNodeset();
      const rootNode = machineStructureNodesetInstance.getRootNode();
      const authContext = store.getState().yourSlice.authContext;
      const source = store.getState().yourSlice.connectionView.source;
      store.dispatch(updateDuplicateStructureIds(duplicateIds));
      errorSnackbar(texts.duplicateNodesError, 20000);

      Sentry.withScope((scope) => {
        scope.setTag("type", "duplicate_id_check");
        scope.setFingerprint(["duplicate_id_check", Date.now().toString()]);
        scope.setUser({
          id: authContext.customerNamespace,
          username: authContext.fullName,
          email: authContext.userInfoForSupportTicket.email,
        });

        scope.setExtra("customer_namespace", authContext.customerNamespace);
        scope.setExtra("source_id", source.source_id);
        scope.setExtra("client_id", source.connected_via_client);
        scope.setExtra("duplicate_node_ids", duplicateIds);
        scope.setExtra(
          "node_structure",
          JSON.stringify(rootNode.toServerChildrenObjectTree()),
        );

        Sentry.captureException(
          new Error("Duplicate IDs detected in structure"),
        );
      });

      return;
    }
  };
